<template>
  <div v-resize="onResize">
    <bulk-btn
        v-if="selection.length"
        :items="selection"
        @bulk-delete="confirmBulkDeleteDialog=true"/>
    <v-data-table
        ref="contactDataTable"
        v-model="selection"
        :show-select="true"
        :loading="loading"
        :loading-text="$t('contacts.loading')"
        :headers="computedHeaders"
        :no-data-text="$t('contacts.tip.noData')"
        :options.sync="pagination"
        :server-items-length="totalRec"
        :items-per-page="defaultItemPerPage"
        :footer-props="footerProps"
        :height="tableHeight"
        :items="contacts"
        id="contacts-iterator"
        @click:row="openDetails">
      <template v-slot:[`item.image`]="{ item }">
        <div>
          <v-avatar size="30">
            <v-img v-if="item.hasImage" :src="item.imageUrl" :alt="item.name"></v-img>
            <v-img v-else src="/default_picture_profile.png" :alt="item.name"></v-img>
          </v-avatar>
        </div>
      </template>
      <template v-slot:[`item.phoneNumbers`]="{ item }">
        <span data-testid="contacts-iterator-phoneNumbers">
          <span v-for="(num, idx) in item.phoneNumbers" :key="idx">
            {{ num.phone_number | formatPhoneNum(countryCode) }}{{ num.extension ? ` (${num.extension})` : '' }}
          </span>
        </span>
      </template>
      <template v-slot:[`item.useAsCallerid`]="{ item }">
        <span :class="item.useAsCallerid ? 'green--text' : 'red--text'">{{ $t(`contacts.columns.cellRenderer.boolean.${item.useAsCallerid}`) }}</span>
      </template>
      <template v-slot:[`item.tags`]="{ item }">
        <v-chip
          v-for="(tag, tagPosition) in item.tagsAsArray" v-bind:key="tagPosition"
          class="ma-1"
        >
          <span>{{ tag }}</span>
        </v-chip>
      </template>
      <template v-slot:[`item.personalTags`]="{ item }">
        <v-chip
          v-for="(tag, tagPosition) in item.personalTagsAsArray" v-bind:key="tagPosition"
          class="ma-1"
        >
          <span>{{ tag }}</span>
        </v-chip>
      </template>
    </v-data-table>
    <confirm-bulk-delete :dialog="confirmBulkDeleteDialog" :contacts="selection" @close="confirmBulkDeleteDialog=false"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BulkBtn from './bulk_btn'
import ConfirmBulkDelete from './confirm_bulk_delete'

export default {
  name: 'contacts-iterator',
  components: { BulkBtn, ConfirmBulkDelete },
  data () {
    return {
      selection: [],
      loading: false,
      pagination: {
        sortBy: ['name'],
        sortDesc: [false]
      },
      tableHeight: 0,
      defaultItemPerPage: 18,
      confirmBulkDeleteDialog: false
    }
  },
  watch: {
    'pagination.page' () {
      this.updateContacts()
    },
    'pagination.itemsPerPage' () {
      this.updateContacts()
    },
    'pagination.sortBy' () {
      this.updateContacts(true)
    },
    'pagination.sortDesc' () {
      this.updateContacts(true)
    },
    contacts () {
      this.resetSelection()
    }
  },
  computed: {
    ...mapGetters({
      contacts: 'contacts/contacts',
      totalRec: 'contacts/total',
      perPage: 'contacts/perPage',
      isPersonal: 'contacts/isPersonal',
      countryCode: 'countryCode'
    }),
    headers () {
      return [
        { text: this.$t('contacts.columns.image'), value: 'image', sortable: false },
        { text: this.$t('contacts.columns.name'), value: 'name' },
        { text: this.$t('contacts.columns.company'), value: 'company' },
        { text: this.$t('contacts.columns.jobTitle'), value: 'job_title' },
        { text: this.$t('contacts.columns.phoneNumbers'), value: 'phoneNumbers', sortable: false },
        { text: this.$t('contacts.columns.useAsCallerid'), value: 'useAsCallerid', sortable: false },
        { text: this.$t('contacts.columns.city'), value: 'city' },
        { text: this.$t('contacts.columns.country'), value: 'country' },
        { text: this.$t('contacts.columns.tags'), value: 'tags', sortable: false },
        { text: this.$t('contacts.columns.personalTags'), value: 'personalTags', sortable: false }
      ]
    },
    footerProps () {
      return {
        'items-per-page-options': [5, 10, 15, 18, 20, 25, 50, 100],
        pageText: this.$t('contacts.footerProps.pageText'),
        'items-per-page-text': this.$t('contacts.footerProps.total')
      }
    },
    computedHeaders () {
      return this.headers.filter(header => {
        return (header.value !== 'personalTags' && header.value !== 'tags') ||
        (header.value === 'personalTags' && this.isPersonal) ||
        (header.value === 'tags' && !this.isPersonal)
      })
    }
  },
  methods: {
    ...mapActions({
      getContacts: 'contacts/get',
      initSearch: 'search/init',
      openDetails: 'contacts/detailsDialog/open',
      setPage: 'contacts/setPage',
      setPerPage: 'contacts/setPerPage',
      setSort: 'contacts/setSort'
    }),
    async resetSelection () {
      this.selection = []
    },
    async updateContacts (isSorting) {
      this.loading = true
      await this.setPage(this.pagination?.page)
      await this.setPerPage(this.pagination?.itemsPerPage)
      if (isSorting) {
        const sortColumn = this.pagination.sortBy[0]
        const sortDirection = this.pagination.sortDesc[0] ? 'DESC' : 'ASC'
        await this.setSort({ sort_column: sortColumn, sort_direction: sortDirection })
      } else {
        await this.getContacts()
      }
      await this.initSearch(this.$t('contacts.searchPlaceholder'))
      this.loading = false
    },
    onResize () {
      const footerHeight = document.querySelector('footer')
      // hack for tests.. :'(
      this.tableHeight = footerHeight ? window.innerHeight - 180 : 800
    }
  }
}
</script>

<style>

</style>
